export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-v1-1200-c18a3cb847473aa288c4dbe9762c780a.webp";